import { useEffect } from "react";
import FormLayout from "../../../components/FormLayout";
import { CitySorryContact } from "./CitySorryContact";

const FilingClosed = () => {
    useEffect(() => { 
        document.title = import.meta.env.VITE_APP_NAME + ' - Filing Closed';
    }, [location]);
    return (
        <FormLayout title={`Filing is closed`} subtitle={""} >
        <div>
            <CitySorryContact description={
                "We’re sorry, but the filing period for the current tax year is closed."
            } />
        </div>
        </FormLayout>
    );
}

export default FilingClosed;